import React from "react";

export default function FormHeader({ children, className }) {
  return (
    <h3 className={`text-xl mb-2 mt-4 font-medium text-gray-900 ${className ?? ""}`}>{children}</h3>
  );
}
